import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../../api";

export default function RegistrationForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [numCourses, setNumCourses] = useState(1);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState([
    {
      user_id: "",
      course_code: "",
      sem: "",
      academic_year: "",
      branch: "",
      teacher_name: "",
    },
  ]);

  const [errorMessage, setErrorMessage] = useState("");
  const [branchdata, setBranchdata] = useState([]);
  // Fetch users data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/users/`);
        const res1 = await api.get(`/api/branch/show`);
        setUsers(res.data);
        setBranchdata(res1.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Handle form field changes
  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFormData = [...formData];
    updatedFormData[index] = { ...updatedFormData[index], [name]: value };
    setFormData(updatedFormData);
  };

  // Filter users by branch and name
  const getFilteredUsers = (branch, teacherName) => {
    return users.filter(
      (user) =>
        user.depart == branch &&
        user.teacher_name.toLowerCase().includes(teacherName.toLowerCase())
    );
  };

  // Handle form submission
  const handleProceedClick = async () => {
    if (handleValidation()) {
      try {
        setLoading(true);
        console.log(formData);
        const response = await api.post(`/api/usercourse/admin/registration`, {
          formData,
        });
        console.log("Successfully updated record:", response.data);
        setIsSubmitted(true);
        setErrorMessage("");
      } catch (error) {
        if (error.response && error.response.data) {
          setErrorMessage(error.response.data.error || "An error occurred.");
        } else {
          setErrorMessage(
            "There was an error saving the registration. Please try again."
          );
        }
      } finally {
        setLoading(false);
      }
    }
  };
  console.log(branchdata);
  console.log(users);
  // Validate form fields
  const handleValidation = () => {
    const requiredFields = [
      "course_code",
      "sem",
      "academic_year",
      "branch",
      "user_id",
    ];
    for (const course of formData) {
      for (let field of requiredFields) {
        if (!course[field] || course[field].toString().trim() === "") {
          alert(`Please fill in the ${field} field for all courses.`);
          return false;
        }
      }
    }
    return true;
  };
  console.log(formData[0]);
  // Generate academic years list
  const generateYearList = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const startMonth = 6;

    const academicYear = (year, month) => {
      return month >= startMonth
        ? `${year}-${year + 1}`
        : `${year - 1}-${year}`;
    };

    let yearList = [];
    for (let i = -5; i <= 2; i++) {
      let year = currentYear + i;
      yearList.push(academicYear(year, currentMonth));
    }
    return yearList;
  };

  const yearList = generateYearList();

  return (
    <div className="left-0 z-45 w-full mt-8">
      <div className="max-w-screen-md mx-auto p-6 border border-gray-300 shadow-lg rounded-md bg-white mt-10">
        <h1 className="text-2xl mb-6 text-blue-500 text-center">
          User Course Form
        </h1>
        {errorMessage && (
          <div className="mb-4 text-red-500">{errorMessage}</div>
        )}

        {isSubmitted ? (
          <div className="text-green-500 text-center mb-4">
            Registration successful!
          </div>
        ) : (
          <form className="space-y-4">
            <div className="flex items-center mb-4">
              <label
                htmlFor="num_courses"
                className="block text-sm font-medium text-gray-700 mr-4"
              >
                How many courses do you want to add?
              </label>
              <input
                type="number"
                id="num_courses"
                value={numCourses}
                onChange={(e) => {
                  const value = Math.max(
                    1,
                    Math.min(parseInt(e.target.value), 10)
                  );
                  setNumCourses(value);
                  const updatedFormData = Array.from(
                    { length: value },
                    (_, index) =>
                      formData[index] || {
                        user_id: "",
                        course_code: "",
                        sem: "",
                        academic_year: "",
                        branch: "",
                        teacher_name: "",
                      }
                  );
                  setFormData(updatedFormData);
                }}
                className="w-20 border border-gray-300 rounded-md shadow-sm p-2"
                min="1"
                max="10"
              />
            </div>

            {formData.map((course, index) => (
              <div
                key={index}
                className="space-y-4 border-b border-gray-300 pb-4 mb-4"
              >
                <h2 className="text-xl mb-4 text-blue-400">
                  Course {index + 1}
                </h2>
                <div className="flex flex-wrap -mx-3 mb-4">
                  <div className="w-full sm:w-1/2 px-3">
                    <label
                      htmlFor={`academic_year_${index}`}
                      className="block text-sm font-medium text-gray-700"
                    >
                      Academic Year
                    </label>
                    <select
                      id={`academic_year_${index}`}
                      name="academic_year"
                      value={course.academic_year}
                      onChange={(e) => handleChange(index, e)}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                      <option value="">Select Year</option>
                      {yearList.map((year, yearIndex) => (
                        <option key={yearIndex} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="w-full sm:w-1/2 px-3">
                    <label
                      htmlFor={`branch_${index}`}
                      className="block text-sm font-medium text-gray-700"
                    >
                      Branch
                    </label>
                    <select
                      id={`branch_${index}`}
                      name="branch"
                      value={course.branch}
                      onChange={(e) => handleChange(index, e)}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                      <option value="">Select Branch</option>
                      {branchdata.map((branch) => (
                        <option key={branch.idbranch} value={branch.idbranch}>
                          {branch.branchname}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex flex-wrap -mx-3 mb-4">
                  <div className="w-full sm:w-1/2 px-3">
                    <label
                      htmlFor={`course_code_${index}`}
                      className="block text-sm font-medium text-gray-700"
                    >
                      Course Code
                    </label>
                    <input
                      type="text"
                      id={`course_code_${index}`}
                      name="course_code"
                      value={course.course_code}
                      onChange={(e) => handleChange(index, e)}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                  </div>

                  <div className="w-full sm:w-1/2 px-3">
                    <label
                      htmlFor={`sem_${index}`}
                      className="block text-sm font-medium text-gray-700"
                    >
                      Semester
                    </label>
                    <select
                      id={`sem_${index}`}
                      name="sem"
                      value={course.sem}
                      onChange={(e) => handleChange(index, e)}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                      <option value="">Select Semester</option>
                      {Array.from({ length: 8 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          Semester {i + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="w-full px-3 mb-4">
                  <label
                    htmlFor={`teacher_name_${index}`}
                    className="block text-sm font-medium text-gray-700"
                  >
                    Teacher Name
                  </label>
                  <input
                    type="text"
                    id={`teacher_name_${index}`}
                    name="teacher_name"
                    value={course.teacher_name}
                    onChange={(e) => handleChange(index, e)}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    placeholder="Type to search..."
                  />
                </div>

                <div className="w-full px-3 mb-4">
                  <label
                    htmlFor={`user_${index}`}
                    className="block text-sm font-medium text-gray-700"
                  >
                    User (Teacher Name)
                  </label>
                  <select
                    id={`user_${index}`}
                    name="user_id"
                    value={course.user_id}
                    onChange={(e) => handleChange(index, e)}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  >
                    <option value="">Select Teacher</option>
                    {getFilteredUsers(course.branch, course.teacher_name)
                      .length > 0 ? (
                      getFilteredUsers(course.branch, course.teacher_name).map(
                        (user) => (
                          <option key={user.userid} value={user.userid}>
                            {user.teacher_name}
                          </option>
                        )
                      )
                    ) : (
                      <option value="">No results found</option>
                    )}
                  </select>
                </div>
              </div>
            ))}

            <button
              type="button"
              onClick={handleProceedClick}
              className="bg-blue-500 text-white rounded-md px-6 py-2 hover:bg-blue-600"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Proceed"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
